import React, { useEffect, useState } from 'react';
export function Header() {
  const [time, setTime] = useState('');
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(now.toISOString().split('T')[1].slice(0, 8) + ' UTC');
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-base/90 backdrop-blur-md hairline-b" data-id="element-140">
      <div className="w-full px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="flex items-center justify-between h-12 font-mono text-xs tracking-widest text-ink/70" data-id="element-142">
          {/* Left: Branding & Status */}
          <div className="flex items-center h-full" data-id="element-143">
            <div className="flex items-center gap-3 pr-6 hairline-r h-full" data-id="element-144">
              <span className="font-bold text-ink" data-id="element-145">DPIP</span>
              <span className="text-indigo-400" data-id="element-146">SYS</span>
            </div>
            <div className="hidden sm:flex items-center gap-2 pl-6" data-id="element-147">
              <div className="w-2 h-2 rounded-full bg-lime animate-pulse-fast" data-id="element-148" />
              <span data-id="element-149">TRACKING ACTIVE</span>
            </div>
          </div>

          {/* Center: Nav */}
          <nav className="hidden md:flex items-center h-full" data-id="element-150">
            <a href="#overview" className="px-4 hover:text-lime transition-colors h-full flex items-center hairline-l" data-id="element-151">
              §01 OVERVIEW
            </a>
            <a href="#tools" className="px-4 hover:text-lime transition-colors h-full flex items-center hairline-l" data-id="element-152">
              §02 DOSSIERS
            </a>
            <a href="#compare" className="px-4 hover:text-lime transition-colors h-full flex items-center hairline-l hairline-r" data-id="element-153">
              §03 SIGNAL BOARD
            </a>
          </nav>

          {/* Right: Time & CTA */}
          <div className="flex items-center h-full" data-id="element-154">
            <div className="hidden lg:block pr-6 hairline-r h-full flex items-center pt-4" data-id="element-155">
              {time}
            </div>
            <div className="pl-6 h-full flex items-center" data-id="element-156">
              <a href="https://waydev.co/demo" target="_blank" rel="noopener noreferrer" className="text-base bg-ink text-base px-4 py-1.5 font-bold hover:bg-lime transition-colors" data-id="element-157">
                [ BOOK DEMO ]
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}